import { render, staticRenderFns } from "./ImageModal.vue?vue&type=template&id=26cb51f2&"
import script from "./ImageModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ImageModal.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports